<template lang="">
    <button type="button" class="add btn btn-primary" style="flex: 1; min-width:200px;"
        @click="sendAddToCart"><span>加入購物車</span></button>
</template>
<script>
    import axios from 'axios';
    import eventHub from '../../../library/event-hub';
    import jQuery from 'jquery';

    export default {
        props: {
            cartData: {
                default() {
                    return {};
                }
            },
            productId: {
                default: undefined
            }
        },
        methods: {
            sendAddToCart() {
                let api_url = `${base_url}/api/carts/add/${this.productId}`;
                axios.post(api_url, this.cartData)
                    .then(success_response => {
                        // console.log('success', success_response);
                        eventHub.$emit('cart-updated', success_response.data);
                        jQuery('.addcart').addClass('clicked');
                        window.setTimeout(() => jQuery('.addcart').removeClass('clicked'), 800);
                    })
                    .catch(error => {
                        if (!error.isAxiosError) console.log('error', [error]);
                        let error_response = error.response;
                        // do something
                        if (error_response.status === 422 &&
                            error_response.data.message === 'payload overload.') {
                            window.alert('Cart Data is full. Please login or checkout to continue shopping.');
                        }
                    });
            }
        }
    }
</script>
<style lang="">

</style>